import React, { Component } from "react";
import { connect } from "react-redux";
import { customerActions } from "redux/actions/customer-action";
import SimpleReactValidator from "simple-react-validator";
import Address from "../../ThemeComponents/Address";
import { objectsConstants as OC } from "redux/constant/objects-constant";
import User from "../../ThemeComponents/User";
import Contact from "../../ThemeComponents/Contact";
import CompanyName from "./CompanyName";
import { withRouter } from "react-router-dom";
import { listActions } from "../../../redux/actions/list-actions";

class EditCustomer extends Component {
    constructor(props) {
        super(props);
        this.validatorCustomer = new SimpleReactValidator();
        this.state = {
            user: OC.user,
            states: [],
            initialState: {
                contact: {
                    first_name: "",
                    last_name: "",
                    email: "",
                    type_id: "",
                    customer_id: ""
                },
                user: {
                    user_name: "",
                    password: "",
                    password_confirmation: ""
                },
                customer: {
                    title: '',
                },
                address: {
                    contact_name: "",
                    line1: "",
                    country_id: "",
                    city: "",
                    region_id: "",
                    zip_post_code: ""
                }
            },
            customer: {
                contact: {
                    first_name: "",
                    last_name: "",
                    email: "",
                    type_id: "",
                    customer_id: ""
                },
                user: {
                    user_name: "",
                    password: "",
                    password_confirmation: ""
                },
                customer: {
                    title: '',
                },
                address: {
                    contact_name: "",
                    line1: "",
                    country_id: "",
                    city: "",
                    region_id: "",
                    zip_post_code: ""
                }
            },
            submitted: false,
            formType: "add",
            isFetched: this.props.match.params.id !== "" ? false : true,
            edit_customer_id: this.props.match.params.id || ""
        };
        //this.onChange = this.onChange.bind(this);
        this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.getChildState = this.getChildState.bind(this);
        this.props.getListCall('country', "", "", "", "", "country", false);
    }

    componentDidMount() {
        const { edit_customer_id } = this.state;
        if (edit_customer_id !== "") {
            this.props.getCustomer(edit_customer_id).then(response => {
                this.setState(prevState => ({
                    customer: this.props.customer,
                    isFetched: true,
                    formType: "edit"
                }));
            });
        } else {
            this.setState(prevState => ({
                isFetched: true
            }));
        }
    }

    getState = state => {
        this.setState(prevState => ({
            customer: {
                ...prevState.customer,
                address: {
                    ...prevState.customer.address,
                    ...state.address,
                }
            }
        }));
    };
    getStateContact = state => {
        this.setState(prevState => ({
            customer: {
                ...prevState.customer,
                contact: {
                    ...prevState.user.customer.contact,
                    ...state.contact
                }
            }
        }));
    };
    getStateUser = state => {
        this.setState(prevState => ({
            customer: {
                ...prevState.customer,
                user: {
                    ...prevState.user.user,
                    ...state.user
                }
            }
        }));
    };
    getStateCompany = state => {
        this.setState(prevState => ({
            customer: {
                ...prevState.customer,
                customer: {
                    ...prevState.customer.customer,
                    ...state
                }
            }
        }));
    };

    handleCustomerSubmit(e) {
        e.preventDefault();
        if (this.validatorCustomer.allValid()) {
            this.setState({
                submitted: true
            });
            const { user, customer, edit_customer_id } = this.state;

            this.props.storeCustomerCall(customer, edit_customer_id);
        } else {
            this.setState({ submitted: false });
            this.validatorCustomer.showMessages();
            this.forceUpdate();
        }
    }

    handleChangeDropdown(selectedOption, info) {
        if (info.name === "state") {
            this.setState({
                customer: {
                    ...this.state.customer,
                    stateId: selectedOption.value
                }
            });
        }
        if (info.name === "country") {
            this.setState(
                {
                    customer: {
                        ...this.state.customer,
                        countryId: selectedOption.value
                    }
                },
                () => {
                    let updatedStates = [];
                    this.props.states.forEach(state => {
                        if (state.countryId === this.state.customer.countryId)
                            updatedStates.push(state);
                    });
                    this.setState({
                        ...this.state.customer,
                        states: updatedStates
                    });
                }
            );
        }
    }

    getChildState(childData) {
        this.setState(
            {
                addressObj: childData
            },
        );
    }

    getUserProps = () => {
        if (this.state.formType === "edit") {
            return this.state.customer;
        } else {
            return this.state.initialState;
        }
    };

    render() {
        // const { user_name, password, password_confirmation } = this.state.user;
        // const {
        //     email,
        //     first_name,
        //     last_name
        // } = this.state.user.customer.contact;
        return (
            <div className="container">
                <h3 style={{ textAlign: "center", fontWeight: "500" }}>
                    {!this.state.edit_customer_id && (
                        <span>Add New Customer</span>
                    )}
                    {this.state.edit_customer_id && <span>Edit Customer</span>}
                </h3>
                <form onSubmit={this.handleCustomerSubmit}>
                    <div className="row">
                        <div className="col-md-8 col-md-offset-2">
                            {this.state.isFetched && (
                                <React.Fragment>
                                    <div className="flexElem addCustomer">
                                        <Contact
                                            contactObject={
                                                this.state.customer
                                            }
                                            contactProp={
                                                this.state.customer
                                            }
                                            requiredField={{
                                                first_name: "required",
                                                last_name: "required",
                                                email: "required"
                                            }}
                                            shippingAddress={false}
                                            htmlElement={"contact"}
                                            returnState={this.getStateContact}
                                            validatorInstance={
                                                this.validatorCustomer
                                            }
                                        />
                                        <User
                                            requiredField={{
                                                user_name: "required",
                                                password: "required",
                                                password_confirmation:
                                                    "required"
                                            }}
                                            htmlElement={"user"}
                                            returnState={this.getStateUser}
                                            validatorInstance={
                                                this.validatorCustomer
                                            }
                                            contactProp={this.getUserProps()}
                                        />
                                        <CompanyName
                                            requiredField={{
                                                title: "required"
                                            }}
                                            htmlElement={"company"}
                                            returnState={this.getStateCompany}
                                            validatorInstance={
                                                this.validatorCustomer
                                            }
                                            companyProp={
                                                this.props.customer.customer.title
                                            }
                                        />
                                    </div>

                                    <Address
                                        addressObject={
                                            this.props.customer.address || OC.ADDRESS
                                        }
                                        formTypePro="edit"
                                        htmlElement={"customer"}
                                        shippingAddress={false}
                                        options={{
                                            countries: this.props.countries
                                        }}
                                        requiredField={{
                                            contact_name: "required",
                                            line1: "required",
                                            country_id: "required",
                                            city: "required",
                                            region_id: "required",
                                            zip_post_code: ""
                                                ? ["integer", "required"]
                                                : ["integer"],
                                            phone: "required",
                                            email: "required"
                                        }}
                                        countries={this.props.country}
                                        getChildState={this.getChildState}
                                        returnState={this.getState}
                                        validatorInstance={
                                            this.validatorCustomer
                                        }
                                    />
                                </React.Fragment>
                            )}
                        </div>

                        <div className="col-md-12 text-center mt-xlg">
                            <input
                                type="submit"
                                value="Update Customer"
                                className="customBtn btnBlue"
                            />
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getCustomer: id => {
            return dispatch(customerActions.getCustomer(id));
        },
        storeCustomerCall: (data, id) => {
            dispatch(customerActions.updateCustomer(data, id));
        },
        getListCall: (
            id,
            page,
            filter,
            sort,
            pageSize,
            component_name,
            pagination
        ) => {
            dispatch(
                listActions.getList(
                    id,
                    page,
                    filter,
                    sort,
                    pageSize,
                    component_name,
                    pagination
                )
            );
        }
    };
};

function mapStateToProps(state) {
    const { country } = state.listReducer;
    const { customer } = state.customerReducer;
    return {
        country,
        customer
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(EditCustomer)
);



// WEBPACK FOOTER //
// ./src/components/Admin/Customers/EditCustomer.jsx